<div *ngIf="selectedOrgWithAccesses && selectedOrgWithAccesses.organization" class="padding-0p3125-1-2p5-1">
  <ng-container data-qa="org-info">
    <div class="padding-right-left-bottom-1">
      <app-organization-info-card
        [isAdmin]="isAdmin"
        [organization]="selectedOrgWithAccesses.organization"
        [orgAccess]="orgAccesses"
        (editOrg)="show.orgUpdate = true">
      </app-organization-info-card>
      <app-modal-organization-update
        *ngIf="show.orgUpdate"
        [updatedOrganization]="selectedOrgWithAccesses.organization"
        (updatedOrg)="updatedOrg($event)">
      </app-modal-organization-update>
    </div>
  </ng-container>
  <div class="padding-right-left-bottom-1 grid-container width-98pcnt">
    <div class="row-container space-between-horizontal">
      <app-tabs
        data-qa="org-user-tabs"
        [tabNamesRaw]="tabNames"
        [isGrey]="true"
        [selectedIndexTab]="tabIndexMap[selectedTab]"
        (selectedTabEmitter)="changeTab($event)" >
      </app-tabs>
      <div
        *ngIf="selectedTab === TabsOrgAndUserManagement.ENTITIES"
        class="row-container row-gap-0p5">
        <app-button
          *ngIf="isAdmin && (orgAccesses.isOrganizationAdmin || orgAccesses.isSuperAdmin)"
          data-qa="add-fund-button"
          [size]="'small'"
          [type]="'accent'"
          [iconName]="'plus.svg'"
          (buttonClick)="showUpdateFundModal({ modalType: FundModalType.CREATE})">
          Fund
        </app-button>
        <app-button
          *ngIf="isAdmin && (orgAccesses.isOrganizationAdmin || orgAccesses.isSuperAdmin)"
          data-qa="add-management-entity-button"
          [size]="'small'"
          [type]="'accent'"
          [iconName]="'plus.svg'"
          (buttonClick)="openCreateEntityModal(true)">
          Management company
        </app-button>
        <app-button
          *ngIf="isAdmin && (orgAccesses.isOrganizationAdmin || orgAccesses.isSuperAdmin)"
          data-qa="add-other-entity-button"
          [size]="'small'"
          [type]="'accent'"
          [iconName]="'plus.svg'"
          (buttonClick)="openCreateEntityModal(false)">
          Other entity
        </app-button>
      </div>
      <div
        *ngIf="selectedTab === TabsOrgAndUserManagement.USERS"
        class="row-container row-gap-0p5">
        <app-button
          *ngIf="orgAccesses.isOrganizationAdmin || orgAccesses.isSuperAdmin"
          data-qa="add-member-button"
          [size]="'small'"
          [type]="'accent'"
          [iconName]="'plus.svg'"
          (buttonClick)="showAddTeamModal()">
          Member
        </app-button>
      </div>
    </div>

    <ng-container [ngSwitch]="selectedTab" class="row-gap-1">
      <ng-container *ngSwitchCase="TabsOrgAndUserManagement.ENTITIES">
        <app-funds-entities-page [isManagementPage]="true"></app-funds-entities-page>
      </ng-container>

      <ng-container *ngSwitchCase="TabsOrgAndUserManagement.USERS">
        <app-user-management #userManagement></app-user-management>
      </ng-container>
    </ng-container>
  </div>
</div>

<app-modal-dialog
  *ngIf="show.deleteEmployee"
  [header]="'Delete member'"
  [mainText]="deleteMemberTextList"
  [addAdditionalText]="true"
  (isConfirmed)="closeModalDeleteUser($event)">
</app-modal-dialog>
